import { combineSlices } from "@reduxjs/toolkit";

import { scoringAnalysisSlice } from "./analysis/analysisSlice";
import { editAnalysisSlice } from "./edit/editAnalysisSlice";
import { rephraseSlice } from "./rephrase/rephraseSlice";

export default combineSlices(
  scoringAnalysisSlice,
  editAnalysisSlice,
  rephraseSlice
);
